import React, {useEffect, useState, useCallback} from 'react';
import GoogleMapReact, { fitBounds } from 'google-map-react';
import MapMarker from "./MapMarker";
import {useDispatch, useSelector} from "react-redux";
import agentsActions from "../../store/actions/agents";
import MapMarkerMultiple from "./MapMarkerMultiple";
const AgentMap = () => {
    const agentsStore = useSelector((store) => store.agentsStore);
    const dispatch = useDispatch();
    const [map, setMap] = useState(null);
    const [zoom, setZoom] = useState(agentsStore.mapZoom)
    const [center, setMapCenter] = useState(agentsStore.mapCenter)
    const [bounds, setBounds] = useState([]);
    const [markers, setMarkers] = useState([]);

    const onLoad = useCallback((map) => setMap(map), []);

    const getMarkers = (agents) => {
        let agentsListArr = []
        agents.forEach(agent => {
            if (agentsListArr.length > 0) {
                for (let i = 0; i < agentsListArr.length; i++) {
                    let compareResultAgent = agentsListArr[i];
                    if (Array.isArray(agentsListArr[i])) {
                        compareResultAgent = agentsListArr[i][0]
                    }
                    if (agent.latitude && agent.longitude && compareResultAgent.latitude && compareResultAgent.longitude) {
                        if (agent.latitude === compareResultAgent.latitude &&
                            agent.longitude === compareResultAgent.longitude
                        ){
                            let agentReplaceItem = agentsListArr[i];
                            agentsListArr[i] = [];
                            agentsListArr[i].push(agentReplaceItem);
                        }
                    }
                }
            }

            agentsListArr.push(agent);
        });

        let bounds = [];

        const agentsListResult = agentsListArr.map((agent, key) => {
            if (Array.isArray(agent) && agent[0].latitude) {
                if (agent[0].latitude) {
                    bounds.push(agent[0])
                }
                return (
                    <MapMarkerMultiple
                        key={agent[0].id}
                        agents={agent}
                        lat={agent[0].latitude}
                        lng={agent[0].longitude}
                    />
                )

            } else if (agent.latitude && agent.longitude) {
                bounds.push(agent)
                return (
                    <MapMarker
                        key={agent.id}
                        agentNumber={agent.agentKey}
                        lat={agent.latitude}
                        lng={agent.longitude}
                        firstName={agent.firstName}
                        middleName={agent.middleName}
                        lastName={agent.lastName}
                        agency={agent.agency.name}
                        id={agent.agentKey}
                    />
                )
            }
        })

        setBounds(bounds);
        setMarkers(agentsListResult);

        return false;
    }

    function handleChange(e) {
        setZoom(e.zoom)
    }

    function handleClick(e) {
        if (e.event.target.classList.length === 0) {
            dispatch(agentsActions.setActiveMarker(''))
        }
    }

    function handleOnload(e) {
        setMap(e.map)
    }



    useEffect(() => {
        setZoom(map?.zoom ?? agentsStore?.mapZoom)
    }, [agentsStore.searchCount])

    useEffect(() => {
        getMarkers(agentsStore.agentsList)
    }, [agentsStore.agentsList])

    useEffect(() => {
        setMapCenter(agentsStore.mapCenter)
    }, [agentsStore.mapCenter])

    useEffect(() => {
        if (map && bounds.length > 1) {
            const boundsResult = new window.google.maps.LatLngBounds();
            bounds.map(marker => {
                boundsResult.extend({
                    lat: parseFloat(marker.latitude),
                    lng: parseFloat(marker.longitude),
                });
            });
            map.fitBounds(boundsResult);
        }
    }, [map, bounds]);

    return (
        <GoogleMapReact
            onGoogleApiLoaded={(e) => handleOnload(e)}
            yesIWantToUseGoogleMapApiInternals
            bootstrapURLKeys={{ key: 'AIzaSyATPcrbhKM-eWB29Oeo-XVpQUkbRgIOJFE' }}
            defaultCenter={{lat: 31.735174102841363, lng: -99.37535083723382}}
            center={agentsStore.mapCenter}
            onChange={(e) => handleChange(e)}
            onClick={(e) => handleClick(e)}
            zoom={zoom}
        >
            {markers}
        </GoogleMapReact>
    )
};

export default AgentMap;

